import { useEffect, useRef } from "react";
import cancelIcon from "../assets/images/cancel-btn.svg";

const CONFIGURATION_FIELDS = [
  {type: "frequency", label: "Frequency", placeholder: "Enter a frequency..."},
  {type: "meal", label: "Meals", placeholder: "Enter meals..."},
  {type: "moment", label: "Moment", placeholder: "Enter a moment..."},
  {type: "qty", label: "Quantity type", placeholder: "Enter a quantity type..."},
  {type: "dose", label: "Dose", placeholder: "Enter a dose..."},
  {type: "unit", label: "Unit", placeholder: "Enter a unit..."},
  {type: "route", label: "Route", placeholder: "Enter a route..."},
  {type: "duration_unit", label: "Duration unit", placeholder: "Enter a duration unit..."},
  {type: "condition", label: "Condition", placeholder: "Enter a condition..."},
  {type: "renewal", label: "Renewal", placeholder: "Enter a renewal..."},
];

const MedicationConfigurationManagement = ({
  configuration,
  isSaving,
  onAdd,
  onRequestDelete,
  onStartCreate,
  onToggleValues,
  onTypeChange,
  onValueChange,
  valuesByType,
}) => {
  const selectedType = configuration?.selectedType || "";
  const selectedField = CONFIGURATION_FIELDS.find(field => field.type === selectedType);
  const isCreating = configuration?.creatingType === selectedType;
  const isValuesOpen = configuration?.openType === selectedType;
  const values = valuesByType?.[selectedType] || [];

  // Focus the "new value" field as soon as it appears (after "+ Create new" or
  // after switching type while creating), caret ready at the start.
  const valueInputRef = useRef(null);
  useEffect(() => {
    if (isCreating && valueInputRef.current) {
      const input = valueInputRef.current;
      input.focus();
      try {
        const end = input.value.length;
        input.setSelectionRange(end, end);
      } catch {
        // some input types don't support setSelectionRange — focus is enough
      }
    }
  }, [isCreating, selectedType]);

  return (
    <div className="configuration_prescription_management">
      <h3>Configuration Medication Administrator</h3>
      <div className="white_form_box">
        <ul className="prescription_management_form_list">
          <li>
            <div className="dropdown">
              <select
                aria-label="Medication configuration type"
                className="dropdown_btn inputBox"
                value={selectedType}
                onChange={event => onTypeChange(event.target.value)}
              >
                {CONFIGURATION_FIELDS.map(field => (
                  <option key={field.type} value={field.type}>
                    {field.label}
                  </option>
                ))}
              </select>
            </div>
          </li>
          <li>
            <div className="dropdown">
              {!isCreating && (
                <button className="dropdown_btn" type="button" onClick={onToggleValues}>
                  Values
                </button>
              )}

              {isCreating && (
                <input
                  ref={valueInputRef}
                  autoFocus
                  aria-label={`New ${selectedField?.label || "configuration"} value`}
                  className="dropdown_btn inputBox"
                  type="text"
                  placeholder={selectedField?.placeholder || "Entrer une valeur..."}
                  value={configuration?.value || ""}
                  onChange={event => onValueChange(event.target.value)}
                />
              )}

              {isValuesOpen && (
                <ul className="dropdown_list">
                  <li>
                    <a onClick={onStartCreate}>+ Create new</a>
                  </li>
                  {values.map((item, index) => (
                    <li key={item?.id ?? index}>
                      <span>{item?.value}</span>{" "}
                      <span onClick={() => onRequestDelete(item)}>
                        <img src={cancelIcon} alt={`Delete ${item?.value || "value"}`} />
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </li>
          <li className="btn_list">
            <button className="btn" type="button" disabled={isSaving} onClick={onAdd}>
              Add
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MedicationConfigurationManagement;
